import { SustainabilityQuiz } from "@/components/shared/SustainabilityQuiz";
import { StickyHeader } from "@/components/shared/StickyHeader";
import { useEffect } from "react";
import { posthog } from "@/lib/posthog";

const Quiz = () => {
  useEffect(() => {
    // Track quiz page view
    if (posthog.__loaded) {
      posthog.capture('quiz_page_viewed', {
        referrer: document.referrer,
      });
    }

    if ((window as any).dataLayer) {
      (window as any).dataLayer.push({
        event: 'page_view',
        page_type: 'quiz',
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <StickyHeader />
      
      <main className="container mx-auto px-4 py-16 md:py-24">
        <SustainabilityQuiz />
      </main>
    </div>
  );
};

export default Quiz;
